import { isESPBoard } from '../buildTargets';

/**
 * Qué placa es, en los términos que necesita la trazabilidad.
 *
 * `board` es la placa de la app: { compilerBoard, profile }. Se acepta también
 * el compilerBoard suelto.
 */

export const PLATFORM = {
  ESP32: 'esp32',
  AVR: 'avr',
};

const normalize = (board) => ((typeof board === 'string') ? { compilerBoard: board } : (board || {}));

/**
 * La plataforma, que es lo que decide cómo lee los módulos el firmware: en ESP32
 * por los pines del Eduplug Power, en AVR por el ADS1115 del Eduplug Mini.
 */
export const platformForBoard = (board = {}) => (isESPBoard(normalize(board).compilerBoard || '') ? PLATFORM.ESP32 : PLATFORM.AVR);

/**
 * Cómo se le nombra la placa al servidor de seriales, que es quien elige el
 * número según el modelo.
 *
 * Son los nombres que tenían los perfiles de la librería hasta la 2.x. La 3.0
 * los sacó -- el firmware ya no recibe perfil, se arregla por plataforma --, pero
 * el servidor los sigue recibiendo en el pedido, así que se mantienen tal cual
 * mientras no se acuerde otro contrato con él.
 *
 * Se mira primero el perfil de la placa y recién después la arquitectura: por
 * compilerBoard no se distinguen entre sí las placas AVR -- una LGO 2.0 compila
 * como arduino:avr:uno igual que una Eduplug Mini, porque las dos son 328P.
 */
const SERVER_PROFILES = {
  eduplugPower: 'Eduplug_power',
  bhoot: 'Bhoot',
  bhootAi: 'Bhoot',
  bhootJR: 'Bhoot',
  lgo20: 'LGO2',
  lgo20Ai: 'LGO2',
};

export const profileForBoard = (board = {}) => {
  const { profile = '' } = normalize(board);
  return SERVER_PROFILES[profile] || (platformForBoard(board) === PLATFORM.ESP32 ? 'Eduplug_power' : 'Eduplug_mini');
};

// Los perfiles que no corren código Arduino compilado: se programan por otro lado.
const PROFILES_WITHOUT_FIRMWARE = ['codit', 'drone', 'drone13'];

/**
 * Si al código de esta placa se le embebe el firmware de trazabilidad.
 *
 * Es por placa y no por transporte: va también cuando se carga por el plugin de
 * escritorio, donde todavía no se habla el protocolo, para que la placa quede con
 * el firmware igual. Queda afuera la micro:bit, que no tiene versión del firmware
 * todavía, y lo que no se compila con el builder de Arduino.
 */
export const boardSupportsFirmware = (board = {}) => {
  const { compilerBoard = '', profile = '' } = normalize(board);
  return !!compilerBoard
    && compilerBoard !== 'microbit'
    && !PROFILES_WITHOUT_FIRMWARE.includes(profile);
};
